import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/axiosInstance";
import { AuthFooter, AuthShell } from "./AuthShell";

export function LegalDocument() {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get("/auth/legal")
      .then((response) => {
        if (!cancelled) setDoc(response.data);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AuthShell>
      <div className="w-full min-w-0 max-w-2xl lg:rounded-2xl lg:border lg:border-lap-hairline lg:bg-lap-card/45 lg:p-10 lg:shadow-2xl lg:shadow-black/25">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-lap-accent-bright">Legal</p>
        <h1 className="mt-2 text-2xl font-extrabold text-white sm:text-3xl">Terms and waiver</h1>
        {error ? (
          <p className="mt-6 text-sm text-lap-loss">Could not load the document. Refresh and try again.</p>
        ) : doc ? (
          <>
            <p className="mt-2 text-xs text-lap-dim">{doc.title} · Version {doc.version}</p>
            <div className="mt-6 max-h-[58dvh] overflow-y-auto rounded-lg border border-lap-hairline bg-lap-bg/70 px-4 py-4 text-sm leading-6 text-lap-text whitespace-pre-wrap sm:px-5">
              {doc.body.replace(/^<!--.*?-->\n/, "").replace(/^# [^\n]+\n+/, "")}
            </div>
          </>
        ) : (
          <p className="mt-6 text-sm text-lap-muted">Loading terms and waiver…</p>
        )}
        <Link className="mt-5 inline-flex text-sm font-medium text-lap-accent-bright hover:text-white" to="/Laptura/login">
          Back to sign in
        </Link>
        <AuthFooter />
      </div>
    </AuthShell>
  );
}
